import { EnumContexto } from './topic.interface';

export interface IConversationCreateRequest {
  contexto?: EnumContexto;
}

export const toConversationCreateRequest = (contexto?: EnumContexto): IConversationCreateRequest =>
  contexto ? { contexto } : {};
